<script setup lang="ts">
import Icon from '../../components/icon/Icon.vue';
import AppShellSidebarFooter from './AppShellSidebarFooter.vue';
import type { AppShellSidebarVariant } from './AppShellSidebarFooter.vue';

export interface AppShellSidebarProps {
	variant?: AppShellSidebarVariant;
	showAppSwitcher?: boolean;
}

withDefaults(defineProps<AppShellSidebarProps>(), {
	variant: 'desktop',
	showAppSwitcher: false,
});

defineEmits<{
	switchApps: [];
	close: [];
}>();
</script>

<template>
	<aside
		:class="[
			'flex h-full min-h-0 flex-col transition-[width] duration-normal',
			variant === 'desktop' ? 'w-70 bg-sidebar' : 'bg-primary-light',
		]"
		:style="{
			paddingTop: 'var(--safe-area-top)',
			paddingBottom: 'var(--safe-area-bottom)',
			...(variant === 'desktop'
				? { backgroundColor: 'var(--ui-color-sidebar, var(--color-sidebar, #545252))' }
				: {}),
		}"
	>
		<div class="flex w-full shrink-0 items-center gap-2 p-4">
			<button
				v-if="variant === 'mobile'"
				type="button"
				class="shrink-0 rounded-md text-primary"
				aria-label="Close menu"
				@click="$emit('close')"
			>
				<Icon name="cancel" size="lg" />
			</button>

			<div
				:class="[
					'flex min-w-0 items-center justify-center overflow-hidden',
					variant === 'mobile' ? 'flex-1' : 'w-full',
				]"
			>
				<slot name="logo" />
			</div>

			<div v-if="variant === 'mobile'" class="w-8 shrink-0" aria-hidden="true" />
		</div>

		<slot />

		<div
			v-if="showAppSwitcher"
			:class="[
				'mt-auto shrink-0 px-5 py-3',
				variant === 'desktop' ? 'border-t border-border-subtle' : '',
			]"
		>
			<AppShellSidebarFooter
				:variant="variant"
				:show-app-switcher="showAppSwitcher"
				@switch-apps="$emit('switchApps')"
			/>
		</div>
	</aside>
</template>
